
import React, { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import { CartContext } from "../context/CartContext";
import "./Contact.css";

export default function Contact() {

  const {
    cartItems,
    updateDescription,
  } = useContext(CartContext);

  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);

  const [showPopup, setShowPopup] = useState(false);

  const handleSubmit = async (e) => {

    e.preventDefault();

    setLoading(true);

    const form = e.target;

    const formData = new FormData(form);

    // SEND PRODUCTS
    formData.append(
      "products",
      JSON.stringify(cartItems)
    );

    try {

      const response = await fetch(
        "https://omkarabrasives.in/submit.php",
        {
          method: "POST",
          body: formData,
        }
      );

      const text = await response.text();

      console.log(text);

      if (text.trim() === "SUCCESS") {

        setShowPopup(true);

        form.reset();

        setTimeout(() => {

          setShowPopup(false);

        }, 2500);

      } else {

        alert(text);
      }

    } catch (error) {

      console.log(error);

      alert("Something went wrong");

    }

    setLoading(false);
  };

  return (

    <div className="contact-page">

      <div className="contact-container">

        {/* LEFT SIDE */}

        <div className="contact-left">

          <h1>
            Send Inquiry
          </h1>

          <p>
            Contact us for Silicon Carbide,
            Aluminum Oxide, Industrial Abrasives,
            Powders, Grains and Bulk Orders.
          </p>

          {cartItems.length > 0 && (

            <div className="selected-products">

              <div className="products-top">

                <h2>
                  Selected Products
                </h2>

                <button
                  onClick={() => navigate("/cart")}
                >
                  Edit Cart
                </button>

              </div>

              {cartItems.map((item, index) => (

                <div
                  className="product-card"
                  key={index}
                >

                  <img
                    src={item.image}
                    alt={item.name}
                  />

                  <div className="product-details">

                    <h3>
                      {item.name}
                    </h3>

                    <span>
                      Qty:
                      {item.quantity}
                    </span>

                    <textarea
                      placeholder="Additional specifications..."
                      value={item.specification}
                      onChange={(e) =>
                        updateDescription(
                          index,
                          e.target.value
                        )
                      }
                    />

                  </div>

                </div>

              ))}

            </div>

          )}

        </div>

        {/* RIGHT SIDE */}

        <form
          className="contact-form"
          onSubmit={handleSubmit}
          encType="multipart/form-data"
        >

          <h2>
            Inquiry Details
          </h2>

          <div className="input-grid">

            <input
              type="text"
              name="name"
              placeholder="Full Name"
              required
            />

            <input
              type="text"
              name="company"
              placeholder="Company Name"
            />

            <input
              type="tel"
              name="mobile"
              placeholder="Mobile Number"
              required
            />

            <input
              type="email"
              name="email"
              placeholder="Email Address"
              required
            />

          </div>

          <textarea
            name="message"
            placeholder="Write your requirement..."
            required
          ></textarea>

          <div className="upload-box">

            <label>
              Upload Files (Optional)
            </label>

            <input
              type="file"
              name="files[]"
              multiple
            />

          </div>

          <button
            type="submit"
            className="submit-btn"
          >

            {loading
              ? "Submitting..."
              : "Submit Inquiry"}

          </button>

        </form>

      </div>

      {/* SUCCESS POPUP */}

      {showPopup && (

        <div className="success-popup">

          <div className="popup-card">

            <h2>
              Inquiry Submitted
            </h2>

            <p>
              Our team will contact you soon.
            </p>

          </div>

        </div>

      )}

    </div>
  );
}
